<template>
    <v-app id="inspire">
      <v-main style="background-color: #24292d; font-family: 'Poppins', sans-serif !important;">
        <cabecerabaja class=" hidden-md-only hidden-lg-only hidden-xl-only" />
          <v-container fluid fill-height align-start>
                <v-row>
                    <v-col  md="12" lg="12" cols="12">
                        <v-card  color="#393E46">
                            <v-card-title>Reportes</v-card-title>
                            <v-card-subtitle>Puerta</v-card-subtitle>
                            <v-card-text>
                                <v-row>
                                    <v-col md="3" lg="3" cols="6">
                                        <v-autocomplete
                                                v-model="idfiesta"
                                                :items="fiestas"
                                                :item-text="item => item.nombre +' - Fecha: '+ item.fechaInicio"
                                                item-value="id"
                                                label="Escoge Fiesta"
                                                persistent-hint
                                                single-line
                                                @change="cambiofecha"
                                        ></v-autocomplete>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col lg="12" md="12" sm="12" cols="12">
                                        <v-sparkline
                                                :labels="labels"
                                                :value="horas"
                                                label-size="3"
                                                show-labels=true
                                                color="white"
                                                smooth="10"
                                                line-width="2"
                                                padding="16"
                                        ></v-sparkline>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col lg="12" md="12" sm="12" cols="12">
<!--                                        <Bar v-if="loaded" :chart-data="chartData" :chart-options="options" />
-->
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
              <v-row>
                <v-col md="4" lg="4" cols="12" sm="12">
                  <v-card color="#393E46">
                    <v-card-title>Reporte por Tipo de Lista</v-card-title>
                    <v-card-text>
                  <v-data-table       :headers="headers2"
                                      :items="tiposlistas"
                                      class="elevation-1"
                                      :loading="progr"
                                      no-data-text="No hay datos disponibles para mostrar."
                                      no-results-text="No hay resultados para la búsqueda."
                                      loading-text="Cargando... Por favor espere."
                                      style="background-color: #393E46;"
                  >

                  </v-data-table></v-card-text></v-card>
                </v-col>
                <v-col md="4" lg="4" cols="12" sm="12">
                  <v-card color="#393E46">
                    <v-card-title>Reporte por Promotor Cabeza</v-card-title>
                    <v-card-text>
                      <v-data-table       :headers="headerscabeza"
                                          :items="reporteCabe"
                                          class="elevation-1"
                                          :loading="progr"
                                          no-data-text="No hay datos disponibles para mostrar."
                                          no-results-text="No hay resultados para la búsqueda."
                                          loading-text="Cargando... Por favor espere."
                                          style="background-color: #393E46;"
                      >

                      </v-data-table></v-card-text></v-card>
                </v-col>
                <v-col md="4" lg="4" cols="12" sm="12">
                  <v-card  color="#393E46">
                    <v-card-title>Reporte por Coordinador</v-card-title>
                    <v-card-text>
                      <v-data-table       :headers="headerscoordinador"
                                          :items="reporteCoord"
                                          class="elevation-1"
                                          :loading="progr"
                                          no-data-text="No hay datos disponibles para mostrar."
                                          no-results-text="No hay resultados para la búsqueda."
                                          loading-text="Cargando... Por favor espere."
                                          style="background-color: #393E46;"
                      >

                      </v-data-table></v-card-text></v-card>
                </v-col>
              </v-row>
                <v-row >
                    <v-col md="12" lg="12" cols="12" sm="12">
                      <v-card color="#393E46">
                        <v-card-title>Reporte por Promotor</v-card-title>
                   <v-card-actions>   <vue-excel-xlsx
                          class   = "btn"
                          :data="reporte"
                          :columns="columns"
                          :file-name="nombreFiesta"
                          :file-type="'xlsx'"
                          :sheet-name="'Promotores'"
                      >
                        <v-btn
                            style="background-color: #6D9886;" > Bajar Excel</v-btn>
                      </vue-excel-xlsx></v-card-actions>
<v-card-text>
<v-data-table       :headers="headers"
                    :items="reporte"
                    class="elevation-1"
                    item-key="idPromotor"

                    :loading="progr"
                    no-data-text="No hay datos disponibles para mostrar."
                    no-results-text="No hay resultados para la búsqueda."
                    loading-text="Cargando... Por favor espere."
                    style="background-color: #393E46;"
>

</v-data-table></v-card-text>
                      </v-card>   </v-col>


                </v-row>
                <leftmenu :abreviado="abreviado" />
              <v-overlay :value="overlay">
                <v-img
                    src="@/assets/loadtunay.gif"

                />
              </v-overlay>
            </v-container>
        </v-main>
    </v-app>
</template>
<script>
    import { mapGetters } from "vuex";
    import leftmenu from '../../general/leftmenu';
    import axios from 'axios';
    import firebase from 'firebase/compat/app';
    import Cabecerabaja from "@/components/general/cabecerabaja";

    export default {
      title: 'Reportes Puerta | Tunay Mi acceso de bolsillo',

      components: {

        Cabecerabaja,
            leftmenu
        },
        data: () => ({
            drawer: null,
            idnegocio: 0,
            fiestas:[],
            reporte:[],
          reporteCoord:[],
          reporteCabe:[],
          abreviado:'NN',
            labels:[],
            horas:[],
          overlay:false,
          nombreFiesta:'',
          tiposlistas:[],
          loaded:false,
            idfiesta: 0,
          token:'',
            fecha: null,
            menu1: false,
            date: new Date().toISOString().substr(0, 10),
            chartData: null,
          options: {
            responsive: true,
            maintainAspectRatio: false
          },
          columns : [
            {
              label: "Promotor",
              field: "promotor_nombre",
            },
            {
              label: "Tipo de Lista",
              field: "tipo_lista_nombre",
            },
            {
              label: "Promotor Cabeza",
              field: "promotor_cabeza_nombre",
            },
            {
              label: "Coordinador",
              field: "coordinador",
            },
            {
              label: "Ingresaron",
              field: "cantidad",
            },

            {
              label: "Total en Lista",
              field: "total",
            },
            {
              label: "Efectividads",
              field: "porcentaje",
            },
            {
              label: "Codigos Generados",
              field: "qrtotal",
            },
            {
              label: "Qrs Canjeados",
              field: "qrCanjeado",
            },
            {
              label: "Ingresaron con Qr",
              field: "qrIngresado",
            },
          ],
            headers: [
        { text: 'Promotor', value: 'promotor_nombre', sortable: true },
        { text: 'Tipo de Lista', value: 'tipo_lista_nombre', sortable: true },
        { text: 'Cabeza',  value: 'promotor_cabeza_nombre'},

              { text: 'En Lista', value: 'total', sortable: true },
              { text: 'Codigos Generados', value: 'qrtotal', sortable: true },
              { text: 'Qrs Canjeados', value: 'qrCanjeado', sortable: true },

              { text: 'Ingresaron con Qr', value: 'qrIngresado', sortable: true },
              { text: 'Ingresaron', value: 'cantidad', sortable: true },
                { text: 'Porcentaje', value: 'porcentaje', sortable: false }
    ],
          headers2: [
            { text: 'Tipo de Lista', value: 'tipoLista', sortable: true },
            { text: 'Ingresaron', value: 'cantidad', sortable: true },
            { text: 'Total en Lista', value: 'total', sortable: true }
          ],
          headerscabeza: [
            { text: 'Promotor Cabeza', value: 'promotorCabeza', sortable: true },
            { text: 'Ingresaron', value: 'cantidad', sortable: true }
          ],
          headerscoordinador: [
            { text: 'Coordinador', value: 'coordinador', sortable: true },
            { text: 'Ingresaron', value: 'cantidad', sortable: true }
          ]
                     }),
        mounted (){
          this.idnegocio =  this.$route.params.idnegocio;
          this.negocio = this.negocios.find(x=>x.tag ===this.idnegocio)
            if (this.usuario.id === undefined){
              this.overlay = true
              firebase
                  .auth()
                  .onAuthStateChanged(user => {
                    if(user){
                      this.overlay = false
                      this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
                      this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno

                      this.damefiestas();
                    }else{
                      this.overlay = false
                      this.$router.push({ path: '/' });
                    }
                  })
            }else{
              this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
              this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno

              this.damefiestas();
            }
        },
        watch: {
          "$store.state.cliente": function (){
            this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
            this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno

            this.damefiestas();
          },
            "$route.params.idnegocio"(value) {
                console.log(value);
                this.idnegocio =  this.$route.params.idnegocio
                this.negocio = this.negocios.find(x=>x.tag ===this.idnegocio)
                        if (this.usuario.id === undefined){
                          this.$router.push({ path: '/' });
                        }else{
                          this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
                          this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno

                          this.damefiestas();
                        }
            }
        },
        methods : {
            formatDate (date) {
                if (!date) return null;
                const [year, month, day] = date.split('-');
                return `${day}/${month}/${year}`;
            },
            parseDate (date) {
                if (!date) return null

                const [day,month, year] = date.split('/')
                return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
            },
            damefiestas(){
                this.progr = true;
              let urlfiesta = 'actos/fiestas/negociotag/' + this.idnegocio ;
                axios
                    .get(urlfiesta,{
                      headers: {
                        'Authorization': `Bearer ${this.token}`,
                      }
                    })
                    .then(response => {
                        this.fiestas = response.data;
                        this.progr = false;
                        this.alertborrador = false;
                        this.alertnuevo = false;
                        this.alerteditar = false;
                    })
                    .catch((error)  => {
                        console.log(error);
                      this.progr = false;
                    });
            },
            cambiofecha(){
              this.nombreFiesta =  this.fiestas.filter(x=>x.id === this.idfiesta)[0].nombre

              let urlreporte = 'lista/fiesta/reporte/' + this.idfiesta ;
              axios
                  .get(urlreporte,{
                    headers: {
                      'Authorization': `Bearer ${this.token}`,
                    }
                  })
                  .then(response => {
                    let jsonspk = response.data.sparklineDTOList;
                    let lbls = [];
                    let valxx = [];
                    jsonspk.forEach(function(data, index) {
                      lbls[index]=data.fechaIngreso;
                      valxx[index]=data.cantidad;
                    });
                    this.labels = lbls;
                    this.horas = valxx;

                    this.chartData = response.data.cantingresoDTO;
                    this.loaded = true

                    this.reporte = response.data.cantIngresoPromDTOList;
                    this.tiposlistas = response.data.reportTipoListaResponses;

                    this.reporteCoord = response.data.reporteCoordinadorFiestas;
                    this.reporteCabe = response.data.reporteCabezaFiestas;

                  })
                  .catch((error)  => {
                    console.log(error);
                  });

            }
        },
    computed: {
        // map `this.user` to `this.$store.getters.user`
        computedDateFormatted () {
            return this.formatDate(this.date)
        },
      ...mapGetters({
        user: "user",
        usuario: "usuario",
        negocios: "negocios",
        cliente: "cliente"
      })
    }
    };
</script>
